// extracted by mini-css-extract-plugin
module.exports = {"root":"_2yNmk8rqDr5E-9fyghWa0i"};